import React, { createRef, ReactNode } from "react";
import { createRoot } from "react-dom/client";
import { showModal } from "@tarojs/taro";
import Dialog, { DialogRef } from "../../DialogComponent";
import Button from "../../../../src/components/Button";
import { XHComponentCommonProps } from "../../../types";

export type AlertProps = {
  title?: string | ReactNode;
  content?: string | ReactNode;
  confirmText?: string | ReactNode;
} & {
  /** 取消按钮的文字，最多 4 个字符 */
  cancelText?: string;
  /** 接口调用结束的回调函数（调用成功、失败都会执行） */
  complete?: (res: TaroGeneral.CallbackResult) => void;
  /** 确认按钮的文字颜色，必须是 16 进制格式的颜色字符串 */
  confirmColor?: string;
  /** 确认按钮的文字，最多 4 个字符 */
  confirmText?: string;
  /** 提示的内容 */
  content?: string;
  /** 接口调用失败的回调函数 */
  fail?: (res: TaroGeneral.CallbackResult) => void;
  /** 接口调用成功的回调函数 */
  success?: () => void;
  /** 提示的标题 */
  title?: string;
} & XHComponentCommonProps;

const Alert = (props: AlertProps): Promise<void> => {
  const { title = "", content, confirmText = "知道了", ...rest } = props;
  return new Promise(resolve => {
    if (process.env.TARO_ENV === "h5") {
      const div = document.createElement("div");
      const dialogRef = createRef<DialogRef>();
      const root = createRoot(div);

      const alertFooter = (
        <Button
          ghost
          type="default"
          shape="rectangle"
          className="xh-alert-button"
          dataTrackId="xh-confirm-footer-confirm-button"
          onClick={() => {
            root.unmount();
            resolve();
          }}
        >
          {confirmText}
        </Button>
      );

      root.render(
        <Dialog
          header={title}
          footer={alertFooter}
          content={content}
          visible
          ref={dialogRef}
          {...rest}
        />
      );
    } else {
      showModal({
        title: title as string,
        content: content as string,
        showCancel: false,
        confirmColor: "#fe5e00",
        confirmText: confirmText as string,
        ...rest,
      }).then(() => resolve());
    }
  });
};

export default Alert;
